export const CONSULTANT_INFO = {
  NAME: "Thermomix Dünyası",
  ID: "TM0000",
  TITLE: "Satış Temsilciniz",
  BIO_INTRO: "Merhaba, ben",
  BIO_TEXT: "Thermomix ile mutfakta harikalar yaratmanız için size rehberlik etmeye hazırım.",
  FULL_NAME_WITH_ID: "Ayşe - TM0000"
};
